export const defaultAttachmentIconStyles = {
  direction: "rtl",
  padding: "0 0 0 8px",
  lineHeight: 0
};